import { useTranslation } from "react-i18next";

const LoadingPage = () => {
    const [t] = useTranslation()

    return (
        <div className="flex flex-col justify-center items-center grow overflow-auto h-screen p-4">
            <img src="assets/images/upload.svg" className="w-full max-h-80 mx-auto" />
            <div className="text-sm font-semibold text-center mt-5">
                در حال دریافت اطلاعات ...
            </div>
        </div>
    )
}

export default LoadingPage